import {Component, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';

export interface User {
  name: string;
  nickname: string;
}

/**
 * @title Display value autocomplete
 */
@Component({
  selector: 'app-auto',
  templateUrl: 'auto.component.html'
})
export class AutoComponent implements OnInit {
  myControl = new FormControl();
  options: User[] = [
    {name: 'Mary', nickname: 'maran'},
    {name: 'Shelley', nickname: 'snäckan'},
    {name: 'Igor', nickname: 'igge'}
  ];
  filteredOptions: Observable<User[]>;

  ngOnInit() {
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith<string | User>(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filter(name) : this.options.slice())
      );
  }

  displayFn(user?: User): string | undefined {
    return user ? user.name : undefined;
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    // tslint:disable-next-line:max-line-length
    return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) !== -1 || option.nickname.toLowerCase().indexOf(filterValue) !== -1);
  }
}
